import EventHandler from '@pixelunion/events';
import { transition } from '@pixelunion/animations';
import * as breakpoint from '@pixelunion/breakpoint';

export default class NewsletterPopup {
  constructor() {
    this.events = new EventHandler();
    this.popup = document.querySelector('[data-popup-opened]');
    this.popupWidth = this.popup.offsetWidth;
    this.popupHeight = this.popup.offsetHeight;
    this.popupPosition = this.popup.classList.contains('newsletter-popup--position-bottom-right')
      ? 'bottom-right'
      : 'center';
    this.popupCloseBtn = document.querySelector('[data-popup-close]');
    this.popupImageClass = 'newsletter-popup--image-true';
    this.delay = window.PXUTheme.theme_settings.newsletter_popup_seconds * 1000;
    this.days = parseInt(window.PXUTheme.theme_settings.newsletter_popup_days, 10);
    this.animatePopup = transition({ el: this.popup, state: 'closed' });

    this._determinePlacement();

    breakpoint.onChange(() => this._determinePlacement());

    if (this.getCookie() === -1) {
      setTimeout(() => {
        this.popup.dataset.popupOpened = true;
        this.animatePopup.animateTo('open');
      }, this.delay);
    }

    this.events.register(this.popupCloseBtn, 'click', () => {
      this.popup.dataset.popupOpened = false;
      this.animatePopup.animateTo('closed');
      this.setCookie();
    });

    this._closeEsc = e => {
      if (e.key === 'Escape') {
        e.stopPropagation();
        this.popup.dataset.popupOpened = false;
        this.animatePopup.animateTo('closed');
        this.setCookie();
      }
    };

    this.closeEscEvent = this.events.register(window, 'keydown', e => this._closeEsc(e));
  }

  // Determines whether or not the popup will be able to fit within the window.
  // If it won't, remove the image.
  _determinePlacement() {
    // The bottom-right layout has a right position of 2.5rem. We need to get the pixel
    // value to calculate if there's room for the popup.
    this.rightOffset = this.popupPosition === 'bottom-right' ? 2.5 * 16 : 0;
    this.bottomOffset = this.popupPosition === 'bottom-right' ? 2.5 * 16 : 0;
    this.willFitHorizontally = window.innerWidth - this.rightOffset > this.popupWidth;
    this.willFitVertically = window.innerHeight - this.bottomOffset > this.popupHeight;

    if (!this.willFitHorizontally) {
      this.popup.classList.remove(this.popupImageClass);
    } else {
      this.popup.classList.add(this.popupImageClass);
    }

    if (!this.willFitVertically) {
      this.popup.classList.add('newsletter-popup--vertical-fit');
    } else {
      this.popup.classList.remove('newsletter-popup--vertical-fit');
    }
  }

  setCookie() {
    if (this.days !== 0) {
      const date = new Date();
      date.setTime(date.getTime() + (this.days * 24 * 60 * 60 * 1000));
      document.cookie = `hide-popup=true; expires="${date.toGMTString()}"`;
    }
  }

  getCookie() {
    if (this.days !== 0) {
      const cookieArray = document.cookie.split(';').map(item => item.trim());
      return cookieArray.indexOf('hide-popup=true');
    }

    return -1;
  }

  unload() {
    if (this.events) {
      this.events.unregisterAll();
    }
  }
}
